import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-100 px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-6 font-display italic text-3xl text-navy-900">
          MahjongHub
        </Link>
        <div className="bg-cream-200 rounded-xl shadow-card p-8">
          <h1 className="font-display text-2xl mb-1">{title}</h1>
          {subtitle && <p className="text-sm text-ink-muted mb-6">{subtitle}</p>}
          {children}
        </div>
        {footer && <div className="text-center text-sm text-ink-muted mt-4">{footer}</div>}
      </div>
    </div>
  );
}
